// tslint:disable: import-name
import AE from "./ae.svg";
import AL from "./al.svg";
import AT from "./at.svg";
import BA from "./ba.svg";
import BE from "./be.svg";
import BG from "./bg.svg";
import BH from "./bh.svg";
import BR from "./br.svg";
import BY from "./by.svg";
import CA from "./ca.svg";
import CH from "./ch.svg";
import CY from "./cy.svg";
import CZ from "./cz.svg";
import DE from "./de.svg";
import DK from "./dk.svg";
import EE from "./ee.svg";
import EG from "./eg.svg";
import ES from "./es.svg";
import FI from "./fi.svg";
import FR from "./fr.svg";
import GB from "./gb.svg";
import GR from "./gr.svg";
import HR from "./hr.svg";
import HU from "./hu.svg";
import IE from "./ie.svg";
import IL from "./il.svg";
import IT from "./it.svg";
import JO from "./jo.svg";
import LT from "./lt.svg";
import LU from "./lu.svg";
import LV from "./lv.svg";
import MD from "./md.svg";
import ME from "./me.svg";
import MK from "./mk.svg";
import MT from "./mt.svg";
import NL from "./nl.svg";
import PL from "./pl.svg";
import PT from "./pt.svg";
import RO from "./ro.svg";
import RS from "./rs.svg";
import RU from "./ru.svg";
import SA from "./sa.svg";
import SE from "./se.svg";
import SI from "./si.svg";
import SK from "./sk.svg";
import TR from "./tr.svg";
import UA from "./ua.svg";
import US from "./us.svg";
import XK from "./xk.svg";

export default {
  AE,
  AL,
  AT,
  BA,
  BE,
  BG,
  BH,
  BY,
  CA,
  CY,
  CZ,
  DE,
  DK,
  EE,
  EG,
  ES,
  FI,
  FR,
  GB,
  CH,
  GR,
  HR,
  HU,
  IE,
  IL,
  IT,
  JO,
  LT,
  LU,
  LV,
  MD,
  ME,
  MK,
  MT,
  NL,
  PL,
  PT,
  RO,
  RS,
  RU,
  SA,
  SE,
  SI,
  SK,
  UA,
  TR,
  BR,
  US,
  XK,
};



// WEBPACK FOOTER //
// ./src/images/countriesFlags/index.js